import { DateTime } from 'luxon'
import { isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { useCallback, useEffect, useRef } from 'react'
import {
  SecondaryTextContainer,
  TabListTitle
} from '../../../../components/stories/organisms/top-navigation/components/global-search/styled-components'
import GlobalSearchNotFound from '../../../../components/stories/organisms/top-navigation/components/global-search/components/not-found'
import { GlobalSearchTabContainer } from '../../../../components/stories/organisms/top-navigation/styled-components'
import HighlightTitle from '../../../../components/stories/organisms/top-navigation/components/global-search/components/highligh-title'
import { Plan } from '../../../../components/stories/atoms/icons/entities'
import BadgesComponent from '../../../../components/stories/atoms/badges'
import {
  badgeColorOptions,
  badgeSizeOptions,
  badgesVariantOptions
} from '../../../../components/stories/atoms/badges/constants'
import ContextMenuComponent from '../../../../components/stories/organisms/context-menu'
import TopBarLoadingContent from '../../../../components/stories/organisms/top-navigation/components/loading-content'
import QuickSelectComponent from '../../../../components/stories/organisms/top-navigation/components/quick-select'
import { useOnInView } from 'react-intersection-observer'
import { FormattedMessage } from 'react-intl'

const CustomPlansTab = ({ search, plansQuery, handleNavigatePlan }) => {
  const { data, isLoading, hasNextPage, isFetchingNextPage, fetchNextPage } =
    plansQuery

  const allPlans = data?.pages.flatMap((d) => d.content) || []

  const onBottomReached = useCallback(() => {
    hasNextPage && !isFetchingNextPage && fetchNextPage()
  }, [hasNextPage, isFetchingNextPage, fetchNextPage])

  const onBottomReachedRef = useRef(onBottomReached)

  useEffect(() => {
    onBottomReachedRef.current = onBottomReached
  }, [onBottomReached])

  const bottomReachedRef = useOnInView(
    useCallback((inView) => {
      if (inView) {
        onBottomReachedRef.current?.()
      }
    }, []),
    {
      rootMargin: '20px',
      skip: !hasNextPage
    }
  )

  const SecondaryText = ({ lastActivity }) => {
    const relativeTime = DateTime.fromISO(lastActivity).toRelative()

    return (
      <SecondaryTextContainer>
        last activity {relativeTime}
      </SecondaryTextContainer>
    )
  }

  if (isLoading) {
    return <TopBarLoadingContent />
  }
  if (isEmpty(allPlans)) {
    return <GlobalSearchNotFound />
  }

  return (
    <GlobalSearchTabContainer>
      {!search && (
        <TabListTitle>
          <FormattedMessage
            id="recently_updated"
            style={{
              textTransform: 'uppercase'
            }}
          />
        </TabListTitle>
      )}
      {allPlans.map((plan, index) => (
        <ContextMenuComponent.Item
          key={plan.id}
          id={plan.id}
          title={<HighlightTitle title={plan.name} query={search} />}
          secondaryText={<SecondaryText lastActivity={plan.lastActivity} />}
          leadingIcon={<Plan />}
          trailingIcon={
            <BadgesComponent
              variant={badgesVariantOptions.STRONG}
              color={badgeColorOptions.DOCU_TOOLS_DARK}
              size={badgeSizeOptions.SMALL}
            >
              {plan.version ?? 0}
            </BadgesComponent>
          }
          style={{ width: '100%', padding: '0.25rem 0.5rem' }}
          onClick={() => handleNavigatePlan(plan)}
        />
      ))}
      {isFetchingNextPage && <QuickSelectComponent.LoadingItem />}

      <div
        ref={bottomReachedRef}
        style={{
          height: '1px'
        }}
      />
    </GlobalSearchTabContainer>
  )
}

CustomPlansTab.propTypes = {
  onClickAction: PropTypes.func,
  search: PropTypes.string,
  projectId: PropTypes.string
}

export default CustomPlansTab
